/**
 * The "👻 cooldown" countdown on the SKU page.
 *
 * A ghost is Best Buy's pickup flag with no store behind it; the pollers then
 * back off that SKU for BESTBUY_GHOST_COOLDOWN_MINUTES (15 since #127). This
 * page used to count 60, so a real ghost read four times too long (#381).
 */
export const GHOST_COOLDOWN_MINUTES = 15; // _ghost_cooldown_minutes() in scripts/stock-tools/lambda_function/lambda_function.py

const parseGhostTime = (value) => {
    let date;
    if (Array.isArray(value) && value.length >= 5) {
        const [year, month, day, hour, minute, second] = value;
        date = new Date(Date.UTC(year, month - 1, day, hour || 0, minute || 0, second || 0));
    } else {
        date = new Date(value);
    }
    return Number.isNaN(date.getTime()) ? null : date;
};

/** Time left on the ghost cooldown as "13m 31s", or null when there is nothing to show. */
export const ghostCooldownRemaining = (stock, now = Date.now()) => {
    if (!stock || !stock.isGhost || !stock.ghostDetectedAt) {
        return null;
    }
    // Best Buy has it in stock, so it is not a ghost whatever the flag says: two
    // pollers can disagree for a few seconds during a drop (#381). The Best Buy
    // columns on purpose - Micro Center stock does not make a Best Buy ghost wrong.
    if (stock.bestBuyInStoreAvailability || stock.bestBuyOnlineAvailability) {
        return null;
    }
    const ghostTime = parseGhostTime(stock.ghostDetectedAt);
    if (!ghostTime) {
        return null;
    }
    const remainingMs = ghostTime.getTime() + GHOST_COOLDOWN_MINUTES * 60 * 1000 - now;
    if (remainingMs <= 0) {
        return null;
    }
    const minutes = Math.floor(remainingMs / 60000);
    const seconds = Math.floor((remainingMs % 60000) / 1000);
    return `${minutes}m ${seconds}s`;
};
